export default function Banner() {
  return (
    <div className="hidden md:flex items-center justify-between bg-[#052e16] px-6 lg:px-10 py-2.5">
      <p className="text-white/50 text-xs tracking-wide" style={{ fontFamily: 'var(--font-body)' }}>
        Empowering wildlife conservation through data-driven intelligence — a LAPA Africa initiative
      </p>
      <p className="text-white/50 text-xs" style={{ fontFamily: 'var(--font-body)' }}>
        +254 716 152699 &nbsp;·&nbsp; info@lapa.africa &nbsp;·&nbsp; Nairobi, Kenya
      </p>
    </div>
  );
}
